<template>
  <div
    class="h-screen flex flex-col justify-center md:justify-around items-center bg-gray-800"
  >
    <div>
      <div class="bubble-wrapper">
        <div ref="bubble" class="bubble">
          <img
            src="@/assets/peter.jpg"
            class="rounded-full w-56 md:w-64 bubble-image"
          />
        </div>
        <div ref="bubblePulse" class="bubble-pulse"></div>
      </div>
      <div
        ref="full_name"
        class="mt-6 tracking-wide text-white text-2xl md:text-3xl"
      ></div>
    </div>
    <navigation />
  </div>
</template>
<script>
import Navigation from "./Navigation";
import { TimelineLite, Back, Elastic, Expo, Power1 } from "gsap";
import { TextPlugin } from "gsap/TextPlugin";

import gsap from "gsap";
gsap.registerPlugin(TextPlugin);

export default {
  components: {
    Navigation,
  },
  mounted() {
    const { bubble, bubblePulse, full_name } = this.$refs;
    const timeline = new TimelineLite();

    timeline.to(bubble, 0.7, {
      scale: 0.8,
      rotation: 16,
      ease: Back.easeOut.config(1.7),
    });

    timeline.to(
      bubblePulse,
      0.5,
      {
        scale: 0.9,
        opacity: 1,
      },
      "-=0.6"
    );

    timeline.to(bubble, 1.8, {
      scale: 1,
      rotation: "-=16",
      ease: Elastic.easeOut.config(2.5, 0.5),
    });

    timeline.to(
      bubblePulse,
      1.5,
      {
        scale: 3,
        opacity: 0,
        ease: Expo.easeOut,
      },
      "-=1.2"
    );

    timeline.to(
      full_name,
      1.5,
      {
        text: {
          value: "< peter-braganza />",
          ease: Power1.easeInOut,
          padSpace: true,
        },
      },
      "-=2.2"
    );
  },
};
</script>


